'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _SenderTypePropType = require('../prop-types/SenderTypePropType');

var _SenderTypePropType2 = _interopRequireDefault(_SenderTypePropType);

var _Avatar = require('./Avatar');

var _Avatar2 = _interopRequireDefault(_Avatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PublicAvatar = function PublicAvatar(_ref) {
  var responder = _ref.responder,
      messageRole = _ref.messageRole,
      isLastInGroup = _ref.isLastInGroup;

  var isAgentsAvatar = messageRole === _senderTypes.AGENT || messageRole === _senderTypes.BOT;

  if (!isAgentsAvatar) {
    return null;
  }

  return _react2.default.createElement(_Avatar2.default, { responder: responder, isLastInGroup: isLastInGroup });
};

PublicAvatar.propTypes = {
  isLastInGroup: _react.PropTypes.bool,
  messageRole: _SenderTypePropType2.default.isRequired,
  responder: _react.PropTypes.instanceOf(_immutable.Record)
};

exports.default = PublicAvatar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/components/PublicAvatar.js
// module id = 1133
// module chunks = 2 3